var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.image
    ? _c("div", { staticClass: "atlas-grid", attrs: { id: "atlas-grid" } }, [
        _vm.image.header_content
          ? _c("div", { staticClass: "atlas-grid__table-header" }, [
              _vm._v("\n        " + _vm._s(_vm.image.header_content) + "\n    ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "atlas-image__container" }, [
          _c("img", {
            attrs: {
              src: _vm.get_src(_vm.image),
              alt: "目前無法讀取",
              width: "100%",
              height: "100%"
            },
            on: {
              click: function($event) {
                return _vm.show_detailed_picture(_vm.image)
              },
              error: function($event) {
                return _vm.change_src(_vm.image)
              }
            }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }